export const checkPermission = (required: number, value: number) =>
  (required & value) === required;
